package br.com.texeratx.boardgametimeapp.ui.screens.players.model

data class PlayerUI(
    val id: Long,
    val name: String,
    val imageUrl: String?,
    val nickname: String?,
    val birthday: String?,
    val phone: String?,
    val clanId: Long
)




